import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { projectBySlugQueryOptions } from '@/entities/project'
import { useSession } from '@/entities/session'
import { Breadcrumb, type Crumb } from '@/shared/ui/breadcrumb'
import { INVOICE_TABS, InvoicePageView } from '../-ui/invoice-page'

const InvoiceSearchSchema = z.object({
  tab: z.enum(INVOICE_TABS).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/$company/$project_/invoices/$invoice')({
  validateSearch: (search) => InvoiceSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Счёт · STIT Deal' }] }),
  component: ProjectInvoicePage,
})

function ProjectInvoicePage() {
  const { company, project, invoice: invoiceId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { session } = useSession()
  const isEmployee = session?.kind === 'employee'

  const projectQ = useQuery(projectBySlugQueryOptions(company, project))
  const d = projectQ.data

  return (
    <InvoicePageView
      invoiceId={invoiceId}
      activeTab={tab ?? 'comments'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      docLink={(docId) => ({
        to: '/$company/$project/documents/$doc',
        params: { company, project, doc: docId },
      })}
      onDeleted={() =>
        void navigate({
          to: '/$company/$project',
          params: { company, project },
          search: { tab: 'invoices' },
        })
      }
      renderBreadcrumb={(inv) => (
        <Breadcrumb
          items={
            [
              isEmployee
                ? {
                    label: d?.company_name ?? company,
                    to: '/companies/$company',
                    params: { company },
                  }
                : { label: d?.company_name ?? company },
              {
                label: d?.title ?? project,
                to: '/$company/$project',
                params: { company, project },
              },
              {
                label: 'Счета',
                to: '/$company/$project',
                params: { company, project },
                search: { tab: 'invoices' },
              },
              { label: inv.number },
            ] satisfies Crumb[]
          }
        />
      )}
    />
  )
}
